export const appConstants = {
  SET_SITE_SETTINGS_SUCCESS: 'APP_SET_SITES_SETTINGS_SUCCESS',
  SET_SITE_SETTINGS_FAILURE: 'APP_SET_SITES_SETTINGS_FAILURE',

  SET_OFFERS_SETTINGS_REQUEST: 'SET_OFFERS_SETTINGS_REQUEST',
  SET_OFFERS_SETTINGS_SUCCESS: 'APP_SET_OFFERS_SETTINGS_SUCCESS',
  SET_OFFERS_SETTINGS_FAILURE: 'APP_SET_OFFERS_SETTINGS_FAILURE',

  SET_GLOBAL_SETTINGS_SUCCESS: 'APP_SET_GLOBAL_SETTINGS_SUCCESS',
  SET_GLOBAL_SETTINGS_FAILURE: 'APP_SET_GLOBAL_SETTINGS_FAILURE',

  SET_SOCIALS_SUCCESS: 'APP_SET_SOCIALS_SUCCESS',
  SET_SOCIALS_FAILURE: 'APP_SET_SOCIALS_FAILURE',

  SET_HEADER_CURRENCY: 'SET_HEADER_CURRENCY',
  SET_ACTIVE_ITEM: 'SET_ACTIVE_ITEM'
};
